export const AUTH_REQUEST="AUTH_REQUEST";
export const AUTH_ERROR="AUTH_ERROR";

export const GET_AUTH_SUCCESS="GET_AUTH_SUCCESS";
export const POST_AUTH_SUCCESS="POST_AUTH_SUCCESS";
export const PATCH_AUTH_SUCCESS="PATCH_AUTH_SUCCESS";
export const DELETE_AUTH_SUCCESS="DELETE_AUTH_SUCCESS";
